/* eslint eqeqeq: "off" */
import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";

const BATCH_TYPE_URL = "api/school-programs/batch-type";
const DELIVERY_TYPE_URL = "api/school-programs/delivery-type";
const PROGRAM_TYPE_URL = "api/school-programs/program-type";
const ACTIVE_URL = "api/school-programs/active";
const COURSE_URL = "api/school-programs/course/";
const SCHOOLS_URL = "api/school-programs/schools/";

export const OFFERED = [
  { id: 1, value: "Yes" },
  { id: 0, value: "No" },
];

export const SHOW = [
  { id: 1, value: "Yes" },
  { id: 0, value: "No" },
];

export const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];


const ProgramContext = createContext();

export function useProgramContext() {
  return useContext(ProgramContext);
}

export const ProgramConsumer = ProgramContext.Consumer;

export function SchoolProgramContextProvider({ programUIEvents, children }) {
  const [BATCH_TYPE, SETBATCH_TYPE] = useState([]);
  const [DELIVERY_TYPE, SETDELIVERY_TYPE] = useState([]);
  const [PROGRAM_TYPE, SETPROGRAM_TYPE] = useState([]);
  const [ACTIVE, SETACTIVE] = useState([]);
  const [COURSE, SETCOURSE] = useState([]);
  const [SCHOOL_INFORMATION, SETSCHOOL_INFORMATION] = useState([]);
  const [SELECT_COURSE_OPTIONS, SETSELECT_COURSE_OPTIONS] = useState([]);
  // const [refetch, setRefetch] = useState(false);
  const branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );
  useEffect(() => {
    const INIT_HELPERS = async () => {
      try {
        let res_camp = await axios(BATCH_TYPE_URL);
        res_camp.data.results = res_camp.data.results.filter(
          (result) => result.id !== 1
        );
        SETBATCH_TYPE(res_camp.data.results);
        let res_delivery = await axios(DELIVERY_TYPE_URL);
        SETDELIVERY_TYPE(res_delivery.data.results);
        let res_program = await axios(PROGRAM_TYPE_URL);
        SETPROGRAM_TYPE(res_program.data.results);
        let res_active = await axios(ACTIVE_URL);
        SETACTIVE(res_active.data.results);
        let res_course = await axios(COURSE_URL + branch.branch_id);
        SETCOURSE(res_course.data.results);
        let school_information = await axios(SCHOOLS_URL + branch.branch_id)
        SETSCHOOL_INFORMATION(school_information.data.results)
        let selectOptions = [];
        res_program.data.results.forEach((pt) => {
          let option = {
            label: pt.value,
            options: res_course.data.results
              .filter((c) => {
                return c.program_type == pt.id;
              })
              .sort((a, b) => (a.value > b.value ? 1 : -1))
              .map((a) => {
                return { value: a.value, label: `${a.value} - ${a.abbr}` };
              }),
          };
          selectOptions.push(option);
        });
        SETSELECT_COURSE_OPTIONS(selectOptions);
        //console.log("results", res_course.data.results);
      } catch (e) {
        console.error(e);
      }
    };
    INIT_HELPERS();
    // eslint-disable-next-line
  }, []);

  const campContext = {
    newProgramButtonClick: programUIEvents.newCampButtonClick,
    openEditProgramPage: programUIEvents.openEditProgramPage,
    openDeleteProgramDialog: programUIEvents.openDeleteProgramDialog,
    openActivateProgramDialog: programUIEvents.openActivateProgramDialog,
    openDuplicateProgramPage: programUIEvents.openDuplicateProgramPage,
    openPointsDialog: programUIEvents.openPointsDialog,
    openEmailDialog: programUIEvents.openEmailDialog,
    openAttendanceDialog: programUIEvents.openAttendanceDialog,
    openFullDialog: programUIEvents.openFullDialog,
    openBulkUploadPage: programUIEvents.openBulkUploadPage,
    refetch: programUIEvents.refetch,
    setRefetch: programUIEvents.setRefetch,
    TYPES: {
      BATCH_TYPE,
      SETBATCH_TYPE,
      DELIVERY_TYPE,
      SETDELIVERY_TYPE,
      PROGRAM_TYPE,
      SETPROGRAM_TYPE,
      ACTIVE,
      SETACTIVE,
      COURSE,
      SETCOURSE,
      OFFERED,
      SHOW,
      SELECT_COURSE_OPTIONS,
      SCHOOL_INFORMATION,
      DAYS
    },
  };

  return (
    <ProgramContext.Provider value={campContext}>{children}</ProgramContext.Provider>
  );
}
